import { fabric } from "fabric";

export const drawLine = (points: number[], properties: fabric.ILineOptions): fabric.Line => {
  const line = new fabric.Line(points, properties);
  return line;
};

export const drawRect = (properties: fabric.IRectOptions): fabric.Rect => {
  const rect = new fabric.Rect(properties);
  return rect;
};

export const drawCircle = (properties: fabric.ICircleOptions): fabric.Circle => {
  const circle = new fabric.Circle(properties);
  return circle;
};
